<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Buat Jenis Komisi</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                        <form class="add-padding-default" action="">
                            <div class="form-group">
                                <label class="remove-margin require color-6f7 letter-space-002" for="namalayanan">Nama Komisi</label>
                                <input type="text" class="form-control inputs" id="namalayanan" aria-describedby="emailHelp"
                                       placeholder="Cuci Kering Setrika" v-model="nama_komisi" v-on:keyup="inputnama">
	                            <ErrorMessage class="error" label="Nama Komisi" :validation="$v.nama_komisi"></ErrorMessage>
                                <div>
                                    <label for="" class="mar-bot-0 mar-top-12 require font-14 color-6f7">Dihitung dari Nota</label>
                                    <div class="row remove-padding-margin">
                                        <div class="remove-padding set-jenissnap mar-bot-8 actvive-border" id="layanan-SS"
                                             style="margin-right: 12px" @click="activeradiobutton">
                                            <div class="input-group">
                                                <div class="custom-control custom-radio remove-padding-lr">
                                                    <input  type="radio" id="allnota" name="allnota" class="custom-control-input"
                                                           data-toggle="collapse" data-target="#collapseTwo"
                                                           aria-expanded="true"
                                                           aria-controls="collapseTwo"  v-on:click="cekValue1" value="0">
                                                    <label class="custom-control-label colorsnap color-206CF font-weight-600" for="allnota"
                                                           id="label-SS">Semua Nota</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="remove-padding set-jenissnap mar-bot-8" id="layanandrop"
                                             @click="activeradiobutton1">
                                            <div class="input-group">
                                                <div class="custom-control custom-radio remove-padding-lr">
                                                    <input  type="radio" id="nota2" name="notalunas" value="1"
                                                            class="custom-control-input"
                                                            data-toggle="collapse" data-target="#collapseTwo"
                                                            aria-expanded="true"
                                                            aria-controls="collapseTwo" v-on:click="cekValue" >
                                                    <label class="custom-control-label colorsnap" for="nota2"
                                                           id="layanan-drop">Nota Lunas Saja</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    <div class="pembatas mar-top-20 mar-bottom-16"></div>
                    <div class="color-0000 font-16 line-height-25 letter-space-002 mar-bottom-16 add-padding-default">Total penjualan akan dihitung dari total nota yang dibayar konsumen dikurangi pajak.</div>
                    <form class="add-padding-default form-main" action="">
                        <div id="form-master">
                            <div class="form-row mar-top-16" v-for="(item, eachData) in cloneCount" v-bind:id="'form' + eachData">
                                <div class="form-group remove-margin flex-1" style="margin-right: 12px">
                                    <label class="remove-margin color-6f7 font-14">Penjualan Mencapai</label>
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16">Rp.</div>
                                        </div>
                                        <input type="tel" class="form-control inputs upah font-16 nominalKey" :data="item" v-bind:id="'omset'+item" @keyup="inputnumberpokok(item)" @change="next" placeholder="2.000.000">
	                                    <ErrorMessage class="error" label="Data Penjualan" :validation="$v.arrayKomisiSalesPost"></ErrorMessage>
                                    </div>
                                </div>
                                <div class="form-group remove-margin" style="width: 100px;margin-right: 12px">
                                    <label class="remove-margin font-14 color-6f7">Komisi</label>
                                    <div class="input-group remove-padding" style="margin-right: 8px">
                                        <input type="text" class="form-control inputs upah font-16" v-bind:id="'komisi'+item" @keyup="max100(item)" @change="next" placeholder="1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16">%</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-end func-remove">
                                    <img class="plus-icon hapusDisable" src="../../assets/icons/hapus_dissable.svg"
                                         alt="" @click="removeForm()">
                                    <img class="plus-icon hapusEnable" style="display:none"
                                         src="../../assets/icons/Hapsu_owner.svg" alt="" @click="removeForm(eachData)">
                                </div>
                            </div>
                        </div>
                        <div class="row color-206CF mar-top-16 remove-mar-lr" @click="addForm">
                            <div class="" style="margin-right: 14px">+</div>
                            <div>Tambahkan target penjualan</div>
                        </div>
                    </form>
                </div>

                <div class="button-lanjut add-padding-default">
                    <button class="btn btn-login btn-long remove-margin" id="btnsetcommision" @click="createcommision" :disabled="!validateAccess('employeesSalesCommision.create')">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textbtncommision">Simpan</span>
                    </button>
                </div>

                <input id="lenght" type="hidden" value="0">

                <div class="modal fade" id="modalmaintance" role="dialog">
                    <div class="modal-dialog modal-lg  bani-modal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="nav-btn kiri"></div>
                                <h5 class="navbar-title text-center">Under Maintance</h5>
                                <div class="nav-btn kanan tutup">
                                    <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                </div>
                            </div>
                            <div class="modal-body">
                                <div class="font-weight-bold color-206CF">Under Maintance</div>
                            </div>
                            <div class="modal-footer remove-mar-lr">
                                <div style="margin-right: 0px">
                                    <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" >UNDER MAINTANCE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import InputPersentase from "@/component-items/InputPersentase";
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "CreateCommision",
	    components: { InputPersentase, ErrorMessage },
        data(){
            return{
                isClickedloader:false,
                isClicked:false,
                choice:[],
                cloneCount: 1,
                data: 1,
                dataCountCheck: 1,
                arrayKomisiSales: [],
	            arrayKomisiSalesPost: [],
                jenis_nota:'0',
                nama_komisi:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    nama_komisi: {
		    	required,
			    minLength: minLength(2),
		    },
		    arrayKomisiSalesPost: {
		    	required,
			    minLength: minLength(1),
		    }
	    },
        mounted() {
            $("#allnota").prop("checked", true);
            this.jenis_nota = '0'
        },
        methods:{
            back(){
                this.$emit("iscreate")
            },

            gocreate(){

            },
            golistkomisi(){
                this.$router.push(({name:'listcommision'}))
            },

            cekValue() {
                var value = $("input[name=notalunas]:checked").val()
                $("#allnota").prop("checked", false);
                this.jenis_nota = value

            },
            cekValue1() {
                var value = $("input[name=allnota]:checked").val()
                $("#nota2").prop("checked", false);
                this.jenis_nota = value

            },

            activeradiobutton() {
                $('#layanan-SS').addClass('actvive-border');
                $('#label-SS').addClass('color-206CF font-weight-600');
                $('#layanandrop').removeClass('actvive-border');
                $('#layanan-drop').removeClass('color-206CF font-weight-600');
                // $('#customRadio1').checked = true
            },

            activeradiobutton1() {
                $('#layanandrop').addClass('actvive-border');
                $('#layanan-drop').addClass('color-206CF font-weight-600');
                $('#layanan-SS').removeClass('actvive-border');
                $('#label-SS').removeClass('color-206CF font-weight-600');
            },

            inputnama(event){
                var nums = event.target.value;
                var nama = nums.replace(/[^0-9A-Za-z_%&.,' -]+/,'');
                this.nama_komisi = nama
                this.cekValidate()
            },

            cekValidate(){
            	return
                var namakomisi = this.nama_komisi;
                var lenght = namakomisi.length;
                if (lenght >= 2) {
                    $('#btnsetcommision').prop('disabled', false);
                } else {
                    $('#btnsetcommision').prop('disabled', true);
                }
            },

            clone(){
                var length = $("#lenght").val();
                var lenghtAdd = parseInt(length) + 1;
                var clone = $('#form-master').clone();
                clone.attr('id', 'reqs' + lenghtAdd);
                var a = clone.children("div").children("div")
                a.attr('key', lenghtAdd);
                a.attr('click', "removeForm(" + lenghtAdd + ")");
                $('.form-main').append(clone);
                $("#lenght").val(lenghtAdd);

                if (lenghtAdd > 0) {
                    $(".hapusDisable").attr("style", "display:none !important");
                    $(".hapusEnable").attr("style", "display:block !important");
                }else{
                    $(".hapusDisable").attr("style", "display:block !important");
                    $(".hapusEnable").attr("style", "display:none !important");
                    $('.func-remove').removeAttr("click")

                }

            },

            // removeForm(key){
            //     var length = $("#lenght").val();
            //     var lenghtMin = parseInt(length) - 1;
            //     $('#reqs'+key).remove();
            //     $("#lenght").val(lenghtMin);
            // },

            addForm() {
                var cloneAdd = this.cloneCount + 1;
                var cloneAdded = this.dataCountCheck + 1;
                this.cloneCount = cloneAdd;
                this.dataCountCheck = cloneAdded;
                this.data = cloneAdded;
                setTimeout(() => {
                    if (this.cloneCount > 1) {
                        $(".hapusDisable").attr("style", "display:none !important");
                        $(".hapusEnable").attr("style", "display:block !important");
                    } else {
                        $(".hapusDisable").attr("style", "display:block !important");
                        $(".hapusEnable").attr("style", "display:none !important");
                    }
                }, 50)
            },

            removeForm(key) {
                $("#form" + key).remove()
                var cloneMin = this.dataCountCheck - 1;
                this.dataCountCheck = cloneMin;
                this.data = cloneMin;
                setTimeout(() => {
                    if (this.dataCountCheck > 1) {
                        $(".hapusDisable").attr("style", "display:none !important");
                        $(".hapusEnable").attr("style", "display:block !important");
                    } else {
                        $(".hapusDisable").attr("style", "display:block !important");
                        $(".hapusEnable").attr("style", "display:none !important");
                    }
                }, 50)
            },

            inputnumberpokok(key){
                var handleevent = $('#omset'+ key).val();
                var handlenumber = handleevent.replace(",", "").replace(/[^0-9]+/,'');
                $('#omset'+ key).val(handlenumber)
                this.formatrupiah(key)
            },

            formatrupiah(key){
                var rupiah = $('#omset'+key).val();;
                var formattedrupiah = this.newrupiah(rupiah);
                $('#omset'+key).val(formattedrupiah)
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            max100(key){
                var inputkomisi = $('#komisi' +key).val()
                // $('.upah').keyup(function(){
                if (inputkomisi> 100){
                    $('#komisi' +key).val('100');
                }
                // });
                this.upahinput(key)
                this.decimal(key)
            },

            upahinput(key){
                var handleeventkomisi = $('#komisi'+ key).val().substring(0,4);
                var handlenumber = handleeventkomisi.replace(/[^0-9,]+/,'');
                $('#komisi'+ key).val(handlenumber)
                // var nums = event.target.value;
                // var number = nums.replace(/[^0-9]+/, '');
                // event.target.value = number;
            },

            decimal(key){
                $('#komisi' + key).keydown(function (e) {
                    //Get the occurence of decimal operator
                    var match = $(this).val();
                    if(match!=null){
                        // Allow: backspace, delete, tab, escape and enter
                        if ($.inArray(e.keyCode, [46,8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }  // Ensure that it is a number and stop the keypress
                        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105 )&&(e.keyCode==190)) {
                            e.preventDefault();
                        }
                    }
                    else{
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    }
                });

                $('#komisi' + key).keyup(function () {
                    if ($(this).val().indexOf('.') != -1) {
                        if ($(this).val().split(".")[1].length >= 2) {
                            if (isNaN(parseFloat(this.value))) return;
                            this.value=parseFloat(this.value).toFixed(2);
                        }
                    }
                })
            },

	        errorValidation() {
		        this.$v.nama_komisi.$touch()
		        this.$v.arrayKomisiSalesPost.$touch()
            	return this.$v.nama_komisi.$invalid || this.$v.arrayKomisiSalesPost.$invalid
	        },
            async createcommision(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true;
                $('#btnsetcommision').prop('disabled', true);
                $('#textbtncommision').hide();
                this.next()
                try {
                    var idowner = localStorage.getItem('idowner')
                    var detail = this.arrayKomisiSalesPost;
                    var createkomisi={
                        "nama": this.nama_komisi,
                        "dihitung_dari_nota": this.jenis_nota,
                        "detail_jenis_komisi_sales": detail
                    };
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/create_jenis_komisi_sales', JSON.stringify(createkomisi), this.requestHeaders);
                    if (response.data.status === true) {
                        this.$emit('islistkomisi')
                        this.nama_komisi=''
                        this.jenis_nota=0
                        this.cloneCount =1
                        $('.upah').val('')
	                    this.$toast.success(response.data.msg)
                        this.isClicked = false;
                        $('#btnsetcommision').prop('disabled', false);
                        $('#textbtncommision').show();
	                    this.arrayKomisiSales = []
	                    this.arrayKomisiSalesPost = []
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.isClicked = false;
                        $('#btnsetcommision').prop('disabled', false);
                        $('#textbtncommision').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false;
	                $('#btnsetcommision').prop('disabled', false);
	                $('#textbtncommision').show();
                }
            },

            next() {
	            this.arrayKomisiSales = []
	            this.arrayKomisiSalesPost = []
            	
                var arrayKomisiStatic = []
	            var arrayKomisiStaticPost = []
                $(".nominalKey").each(function (index) {
                    var idData = $(this).attr("data");
                    var nominalKomisi = $("#omset" + idData).val();
                    var percentageKomisi = $("#komisi" + idData).val().toString().replace(",", ".");
                    var fixed2 = parseFloat(percentageKomisi)
                    var fix = fixed2.toFixed(2)
                    arrayKomisiStatic.push({
                        total_omset: nominalKomisi,
                        persentase_komisi: fix,
                    });
	                arrayKomisiStaticPost.push({
		                total_omset: nominalKomisi.toString(),
		                persentase_komisi: fix,
	                });
                });
                this.arrayKomisiSales = arrayKomisiStatic
	            this.arrayKomisiSalesPost =arrayKomisiStaticPost
            }
        }
    }
</script>

<style scoped>
    .set-jenissnap {
        background: #FFFFFF;
        border: 1px solid #C8D0DD;;
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        flex-direction: row;
        padding: 8px 10px;
    }

    .actvive-border {
        background: rgba(32, 108, 255, 0.1);
        border: 1px solid rgba(32, 108, 255, 0.35);
    }
</style>